import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Asset } from '@models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AssetService {
  private _http = inject(HttpClient);

  fetchAssets(): Observable<Asset[]> {
    return this._http.get<Asset[]>(`/assets`);
  }
}
